export default __webpack_public_path__ + "static/uservoice-32b3239cb9eb39c07664df300232d43b.avif";